<div
  *ngIf="selected$ | async"
  role="tabpanel"
  [attr.id]="'tab-' + tabId + '-content'"
  [attr.aria-labelledby]="'tab-' + tabId"
>
  <ng-content></ng-content>
</div>
